export const environment = {
    production: false,
    loginUrl: "login",
    localTokenKey: "token",
    ssoTokenKey: "token",
    loginType: "local",
    storeAccessToken: "sessionstorage",
    csrfTokenCookieName: "csrfToken",
    checkTokenValidityBeforeExpireMin: 10,
    baseHref: "/",
    flickeringServicesResponse: 0,
    /** Nome standard del file usato per la configurazione dei vari ambienti **/
    configurationFileName: "config.json",
    /** Path per l'inizializzazione dell'ambiente di sviluppo */
    configurationDevPath: "./assets/config/dev/config.json",
    /** Path per l'inizializzazione dell'ambiente di certificazione */
    configurationStagingPath: "./assets/config/staging/config.json",
    /** Path per l'inizializzazione dell'ambiente di produzione */
    configurationProdPath: "./assets/config/prod/config.json",
    /** Path per l'inizializzazione della configurazione comune a tutti gli ambienti */
    commonConfiguration: "./assets/config/common-config.json",
    loggerLevel: 1,
    recaptchaKey: "6LeAUawrAAAAAB9EGNqf9XSQtn5JMLijMlg4_IM9",
    /** Chiave pubblica VAPID per notifiche push */
    vapidPublicKey: "BGXkBjOtKWgMajUjHLDR7xajZ2b9aRZl29bsG8_4VqMg2ASwUFi6RGDLelJj3ZJc_NYe9dWVV3Yi8Y1KPkXwhA8"
};